import React from 'react';
import BarChartOutlined from '@material-ui/icons/BarChartOutlined';

const StatisticsIcon = ({ color }) => <BarChartOutlined style={{ color }} />;

export default StatisticsIcon;
